import React from 'react';
import { Box, Container } from '@mui/material';
import ContactUsTitle from '../components/ContactUsPage/ContactUsTitle';
import ContactDescription from '../components/ContactUsPage/ContactDescription';
import ContactForm from '../components/ContactUsPage/ContactForm';
import OfficeInfo from '../components/ContactUsPage/OfficeInfo';

const ContactUsPage = () => {
  return (
    <Box>
      <ContactUsTitle />
      <Container maxWidth="lg" sx={{ py: 6 ,pb:0}}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <Box 
            sx={{ 
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '2fr 1fr' },
              gap: { xs: 4, md: 8 },
              mb: 2
            }}
          >
            <ContactDescription />
            <OfficeInfo />
          </Box>
          <ContactForm />
        </Box>
      </Container>
      <Box
        sx={{
          width: '100%',
          height: '100px',
          background: 'linear-gradient(to bottom, #FFFFFF 0%, #F7F9FC 100%)',
        }}
      />
    </Box>
  );
};

export default ContactUsPage; 